import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=5b2a4c0a&scoped=true&"
import script from "./MainTitle.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MainTitle.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=5b2a4c0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a4c0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2a4c0a')) {
      api.createRecord('5b2a4c0a', component.options)
    } else {
      api.reload('5b2a4c0a', component.options)
    }
    module.hot.accept("./MainTitle.vue?vue&type=template&id=5b2a4c0a&scoped=true&", function () {
      api.rerender('5b2a4c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/MainTitle.vue"
export default component.exports